/* eslint-disable sonarjs/no-duplicate-string */
import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  messageEmptyItems: {
    id: "b2b.message.empty.items",
    defaultMessage: "No records found"
  }
});

export default () => useMessages(MESSAGES);
